/**
 * Usage example:
 * ```
 * const nameof = nameofFactory<Button>();
 * const propName = nameof('aPropertyName')
 * ```
 */
export const nameofFactory = <T>() => (name: Extract<keyof T, string>): string => name;
